import { Box, Container, Tab, Tabs, Typography } from '@mui/material';
import LibraryBooksIcon from '@mui/icons-material/LibraryBooks';
import SearchIcon from '@mui/icons-material/Search';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';

import { SelectionTray } from './components/cart/SelectionTray';
import { STANDARDS_FIND_PATH, STANDARDS_LIBRARY_PATH } from './paths';

import { useAppSelector } from '@/shared/hooks/redux';

/** Shell for the V2 Standards page: title + My Library / Find Standards tabs over a routed Outlet. */
export default function StandardsLibraryShell() {
  const location = useLocation();
  const navigate = useNavigate();
  const tab = location.pathname.startsWith(STANDARDS_FIND_PATH) ? 'find' : 'library';
  const cartCount = useAppSelector((state) => Object.keys(state.standardsCart.items).length);

  return (
    <Box sx={{ py: 3, pb: { xs: cartCount > 0 ? 10 : 3, md: 3 } }}>
      <Container maxWidth="xl">
        <Typography variant="h2" component="h1" sx={{ mb: 1.5 }}>
          Standards
        </Typography>
        <Tabs
          value={tab}
          onChange={(_event, value) =>
            navigate(value === 'find' ? STANDARDS_FIND_PATH : STANDARDS_LIBRARY_PATH)
          }
          sx={{ mb: 2, borderBottom: 1, borderColor: 'divider' }}
        >
          <Tab
            value="library"
            icon={<LibraryBooksIcon fontSize="small" />}
            iconPosition="start"
            label="My Standards"
          />
          <Tab
            value="find"
            icon={<SearchIcon fontSize="small" />}
            iconPosition="start"
            label="Find Standards"
          />
        </Tabs>
        <Box sx={{ display: 'flex', gap: 2, alignItems: 'stretch' }}>
          <Box sx={{ flex: 1, minWidth: 0 }}>
            <Outlet />
          </Box>
          <SelectionTray />
        </Box>
      </Container>
    </Box>
  );
}
